import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const links = [
  { id: "titles", label: "Work" },
  { id: "ai", label: "AI" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const [active, setActive] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    if (!isHome) {
      return () => window.removeEventListener("scroll", onScroll);
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    links.forEach((l) => {
      const el = document.getElementById(l.id);
      if (el) observer.observe(el);
    });
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer.disconnect();
    };
  }, [isHome]);

  // Navigate to a home-page anchor from anywhere.
  const goToAnchor = (e, id) => {
    if (isHome) {
      e.preventDefault();
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      e.preventDefault();
      navigate(`/#${id}`);
    }
  };

  return (
    <nav
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-50 lr-nav-reveal"
      style={{
        background: scrolled ? "#080808" : "transparent",
        borderBottom: scrolled ? "1px solid #141414" : "1px solid transparent",
        transition: "background 400ms ease, border-color 400ms ease",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-brand"
          className="text-xl md:text-2xl tracking-tight"
          style={{ color: "#F5F5F3", fontWeight: 600, letterSpacing: "-0.02em" }}
        >
          Livingroom<span style={{ color: "#FF6A3D" }}>.</span>
        </Link>

        <div className="hidden md:flex items-center gap-8 lg:gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={`/#${l.id}`}
              onClick={(e) => goToAnchor(e, l.id)}
              data-testid={`nav-link-${l.id}`}
              data-active={active === l.id ? "true" : "false"}
              className="lr-nav-link text-[11px] uppercase"
              style={{ letterSpacing: "0.24em", fontWeight: 500 }}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/production-in-poland"
            data-testid="nav-link-poland"
            aria-label="Produce in Poland"
            data-active={
              location.pathname === "/production-in-poland" ? "true" : "false"
            }
            className="lr-nav-link text-[11px] uppercase whitespace-nowrap"
            style={{ letterSpacing: "0.22em", fontWeight: 500 }}
          >
            Produce in Poland
          </Link>
        </div>

        <a
          href="/#contact"
          onClick={(e) => goToAnchor(e, "contact")}
          data-testid="nav-cta"
          className="hidden md:inline-flex text-[11px] uppercase"
          style={{
            letterSpacing: "0.24em",
            color: "#FF6A3D",
            borderBottom: "1px solid #FF6A3D",
            paddingBottom: 2,
            fontWeight: 500,
          }}
        >
          Start a project
        </a>

        <a
          href="/#contact"
          onClick={(e) => goToAnchor(e, "contact")}
          data-testid="nav-cta-mobile"
          className="md:hidden text-[11px] uppercase"
          style={{ letterSpacing: "0.24em", color: "#FF6A3D", fontWeight: 500 }}
        >
          Contact
        </a>
      </div>
    </nav>
  );
};

export default Nav;
